$(document).ready(function(){
  	$.ajax({
         url: '/cart.js',
         dataType: "json",
         cache: false,
         success: function( cart ) {
               if ( cart.item_count > 0 ) {
                  $('.ths-loader').show();
                  CreateCartPageHtml( cart );
               }
         }
    });
});


var CreateCartPageHtml = function ( cart ) {
 
  	  	var bundle_image_url1 = "//www.explorethousand.com/cdn/shop/files/thousand_bundle.jpeg?v=135617";
       	var bundle_image_url = "https://cdn.shopify.com/s/files/1/0836/6919/files/thousand_bundle.jpg?v=1652761411";
  		var cart_items_html = "";
  		var bundle_product = false;
        var bundle_products_data = {};

      	$.each( cart.items, function( index, item ) {
          
          	if( typeof item.properties._btype != 'undefined' ) {
            	
            	bundle_product = true;	
            	bundle_products_data[item.properties._btype] = ( typeof bundle_products_data[item.properties._btype] == 'undefined' ) ? [] : bundle_products_data[item.properties._btype];
            	if( item.handle == 'monogram' || item.handle == "thousand-jr-monogram"  ) {
            		bundle_products_data[item.properties._btype].push({ 'initials': item.properties.Initials, 'helmet': item.properties.Helmet, 'name' : item.title, 'price' : item.price, 'varient_id' : item.variant_id, 'discounted_price' : item.discounted_price  });
                }else {
                    bundle_products_data[item.properties._btype].push({ 'name' : item.title, 'price' : item.price, 'varient_id' : item.variant_id , 'discounted_price' : item.discounted_price });
                }
                
          } else {
            
            	var discountMessage = "";
                if( typeof item.discounts != 'undefined' ) {	
                  var itemDiscounts = item.discounts;
                  for (i=0; i < itemDiscounts.length; i++) {
                        var amount = formatMoneyStripTrailingZeros(itemDiscounts[i].amount, $('body').data('money-format'));
                        var title = itemDiscounts[i].title;
                        discountMessage = '<div class="meta"> <span class="label"> Discount :</span> ' + title + ' (-<span class="money"> ' + amount + '</span>)</div>';
                  }
                }
            
				cart_items_html += '<div class="section clearfix cart_item cart_item__' + handleize(item.product_title) + ' cart_item-type__' + handleize(item.product_type) + '">';
            	cart_items_html += '<div class="five columns alpha">';
            	cart_items_html += '<a href="' + item.url +'" title="' + item.title +'" class="cart_page_image">';
				cart_items_html += '<img src="' + item.featured_image.url + '" alt="' + htmlEncode(item.title) + '" />';
				cart_items_html += '</a>';
                cart_items_html += '</div>';
            	
            	cart_items_html += '<div class="eleven columns omega cart_content_info cart_item__title" data-variant="' + item.variant_title + '" data-key="' + item.key + '">';
				cart_items_html += '<div class="item_title"> ';
            	cart_items_html += ' <h3> <a href="' + item.url +'">'+item.title+'</a> </h3>';
            
				if( item.properties ) {
                  $.each( item.properties, function( title, value ) {
                    if (value) {
                      cart_items_html += '<div class="line-item line-item--' + handleize(title) + '"><span class="line-item__title">' + title +': </span><span class="line-item__value">' + value + '</span></div>';
                    }
                  });
            	}
            
            	cart_items_html += '<div class="modal_price"> <span class="money"><span class="money-text">Price:</span> '+formatMoneyStripTrailingZeros(item.discounted_price, $('body').data('money-format'))+'</span></div>';
             	if ( item.price > item.final_price ) {
              		cart_items_html +=  discountMessage;
            	}
            
            	var itemPrice = formatMoneyStripTrailingZeros(item.discounted_price * item.quantity , $('body').data('money-format')) + '</span>';
              	if ( item.price != item.discounted_price  ) {
                  	itemPrice += '<span class="money was_price">' + formatMoneyStripTrailingZeros(item.price * item.quantity, $('body').data('money-format')) + '</span>';
              	}
             	
            	cart_items_html += '<div class="price_total"> <strong>Total:</strong>';
                cart_items_html += '<span class="money">' + itemPrice + '</strong></div>';
                
            	var line_id = index + 1;
            	cart_items_html += '<div class="left product-quantity-box">' +
                	'<span class="ss-icon product-minus js-change-quantity" data-func="minus"><span class="icon-minus"></span></span>' +
                	'<input type="number" min="0" class="quantity" name="updates[]" id="updates_' + item.id + '" value="' + item.quantity +'" data-line-id="' + line_id +'" />' +
                	'<span class="ss-icon product-plus js-change-quantity" data-func="plus"><span class="icon-plus"></span></span>' +
              		'</div>';
            
            	cart_items_html += '</div> ';
            	cart_items_html += '</div> ';
            	cart_items_html += '</div> ';
            
          }
          
        });
  
  
  		if( bundle_product ) {
          
          	$.each( bundle_products_data, function( key, bproduct ){
              	var bprice = 0;
              	var dprice = 0;
              	var products_ids = [];
         
              	cart_items_html += '<div class="section clearfix cart_item cart_item__bundle cart_item-type__bundle">';
            	cart_items_html += '<div class="five columns alpha">';
            	cart_items_html += '<a href="'+kit_page_url+'" title="bundle" class="cart_page_image">';
				cart_items_html += '<img src="' + bundle_image_url + '" alt="" />';
				cart_items_html += '</a>';
                cart_items_html += '</div>';
            	
            	cart_items_html += '<div class="eleven columns omega cart_content_info cart_item__title" data-variant="" data-key="">';
				cart_items_html += '<div class="item_title"> ';
            	cart_items_html += ' <h3> <a href="' + bundle_image_url +'"> Helmet Bundle </a> </h3>';
              	cart_items_html += '<ul>';	
              
              	var array_reverse = bproduct.reverse();
              	array_reverse.forEach( function ( sproduct, index ) {
                  	products_ids.push(sproduct.varient_id)
                  	bprice += sproduct.price;
                  	dprice += sproduct.discounted_price;
                  	var ptitle = ( typeof sproduct.initials != 'undefined' ) ?  sproduct.name + ' / ' + sproduct.initials  : sproduct.name;
                  	cart_items_html += '<li><strong>' + ptitle + '</strong></li>';	
//                     cart_items_html += '<div class="line-item line-item--' + handleize(title) + '"><span class="line-item__title">' + title +': </span><span class="line-item__value">' + value + '</span></div>';
                });
              	
                cart_items_html += '</ul>';
            	cart_items_html += '<div class="modal_price"> <span class="money"><span class="money-text">Price:</span> '+formatMoneyStripTrailingZeros(dprice, $('body').data('money-format'))+'</span></div>';
            
              	 var bundle_price_html = formatMoneyStripTrailingZeros(dprice, $('body').data('money-format')) + '</span>';
              	if ( bprice != dprice  ) {
                  	bundle_price_html += '<span class="money was_price">' + formatMoneyStripTrailingZeros(bprice, $('body').data('money-format')) + '</span>';
              	}
             	
            	cart_items_html += '<div class="price_total"> <strong>Total:</strong>';
                cart_items_html += '<span class="money">' + bundle_price_html + '</strong></div>';
              	
                cart_items_html += '<div class="edit_bundle"><a href="'+kit_page_url+'?btype='+key+'" >Edit bundle</a></div>';
              	cart_items_html += '<div data-page="cart" data-ids="'+ products_ids +'" data-bundle="'+key+'" class="delete_bundle"><a href="javascript:void(0)">Delete bundle</a></div>';

              
            	cart_items_html += '</div> ';
            	cart_items_html += '</div> ';
            	cart_items_html += '</div> ';
              
            });
          
        }
  
  		$('.cart_items').html(cart_items_html);
  	    $('.ths-loader').hide();
  
}